import { render } from "./QuestionTwoScreen.vue?vue&type=template&id=59588b8e&scoped=true&lang=html"
import script from "./QuestionTwoScreen.vue?vue&type=script&lang=js"
export * from "./QuestionTwoScreen.vue?vue&type=script&lang=js"

import "./QuestionTwoScreen.vue?vue&type=style&index=0&id=59588b8e&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_topdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59588b8e"]])

export default __exports__